import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import CustomDateTimePicker from "../../components/CustomInputs/CustomDateTimePicker";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import ProfileContext from "../../components/ProfileContext";
import Toast from "../../components/ToastContainer/CustomToast";
import httpCommon from "../../config/http-common";
import { getListSettings } from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import { createPreRegistration } from "../../slices/Invitations/InvitationsSlice";
import { getAllSites } from "../../slices/Site/SiteSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";

export default function CreatePerRegistration(props) {
  const { open } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [siteData, setSiteData] = useState([]);
  const [changeDate, setDateChange] = useState(true);
  const { setCurrentTotalVisitCount } = useContext(ProfileContext);
  const [date, setDate] = useState(props.date);
  const { darkMode } = useContext(ThemeContext);
  const [siteTimeEnable, setSiteTimeEnable] = useState(true);
  const [siteCurrentDateTime, setSiteCurrentDateTime] = useState(null);

  var minutes =
    props.perRegistrationIntervalTime === ""
      ? 30
      : Number(props.perRegistrationIntervalTime);
  const [
    perRegistrationIntervalTime,
    setPerRegistrationIntervalTime,
  ] = useState(minutes);

  var today = new Date();

  useEffect(() => {
    loadSetting();
  }, []);

  const loadSetting = () => {
    dispatch(getListSettings())
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setPerRegistrationIntervalTime(data.data.walkInIntervalTime);
          setDate(formatDate(data.data.dateFormat));
        }
      });
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T" +
    (today.getHours() < 10 ? "0" + today.getHours() : today.getHours()) +
    ":" +
    (today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes());

  const [payload, setPayload] = useState({
    firstName: "",
    lastName: "",
    siteId: "",
    scheduledStartDate: CommonUtil.formatLocalDateTime(startDate),
    scheduledEndDate: CommonUtil.formatLocalDateTime(
      moment(startDate).add(perRegistrationIntervalTime, "minutes"),
    ),
    visitMode: "PRE_REGISTRATION",
    profilePhoto: "str.jpg",
    remarks: "",
  });

  const [error, setError] = useState({
    firstName: false,
    lastName: false,
  });

  const handleClose = () => {
    props.handleDialogClose();
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
    setError({
      [name]: false,
    });
  };

  useEffect(() => {
    loadData(props.open);
  }, []);

  const loadData = () => {
    loadSites();
  };

  const loadSites = () => {
    const query = {
      page: 1,
      rowsPerPage: 10000,
      name: "",
    };
    dispatch(getAllSites(query))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI0000") {
          setSiteData(data.data.site);
        } else {
          setSiteData([]);
        }
      });
  };

  // Only one site available: select it automatically and load its schedule time
  useEffect(() => {
    if (siteData.length === 1) {
      const site = siteData[0];
      setPayload((prev) => ({
        ...prev,
        siteId: site,
        siteTimeZone: site.timeZone ? site.timeZone : "",
      }));
      setError((prev) => ({ ...prev, siteId: false }));
      getSiteCurrentDateTime(site.id);
    }
  }, [siteData]);

  const handleSumbit = () => {
    if (CommonUtil.isEmptyString(payload.firstName)) {
      Toast(t("USERPROFSCREEN007"), "error");
      setError({ firstName: true });
      return;
    }
    if (!CommonUtil.isValidNames(payload.firstName)) {
      Toast("Please Enter Valid First Name ", "error");
      setError({ firstName: true });
      return;
    }

    if (CommonUtil.isEmpty(payload.siteId)) {
      Toast(t("Site is mandatory"), "error");
      setError({ selectedHost: true });
      return;
    }
    if (
      payload.scheduledStartDate === null ||
      payload.scheduledStartDate === undefined ||
      payload.scheduledStartDate === ""
    ) {
      setError({ scheduledStartDate: true });
      Toast(t("INVITATIONFORM011"), "error");
      return;
    }
    if (
      payload.scheduledEndDate === null ||
      payload.scheduledEndDate === undefined ||
      payload.scheduledEndDate === ""
    ) {
      setError({ scheduledEndDate: true });
      Toast(t("INVITATIONFORM012"), "error");
      return;
    }
    if (
      new Date(payload.scheduledStartDate) < new Date(payload.scheduledEndDate)
    ) {
      const dto = {
        firstName: !CommonUtil.isEmpty(payload.firstName)
          ? payload.firstName
          : null,
        lastName: !CommonUtil.isEmpty(payload.lastName)
          ? payload.lastName
          : null,
        scheduledStartDate: CommonUtil.formatLocalDateTime(
          payload.scheduledStartDate,
        ),
        scheduledEndDate: CommonUtil.formatLocalDateTime(
          payload.scheduledEndDate,
        ),
        visitMode: payload.visitMode,
        siteId: payload.siteId.id,
        siteTimeZone: payload.siteTimeZone,
        remarks: !CommonUtil.isEmpty(payload.remarks)
          ? payload.remarks.trim()
          : null,
      };

      dispatch(createPreRegistration(dto))
        .unwrap()
        .then((data) => {
          if (data.code === "MSGS4000") {
            Toast(t("PER_REGISTRATION_CREATE_SUCCESSFULLY"), "success");
            setCurrentTotalVisitCount(data.data.currentVisitCount);
            props.loadData();
            handleClose();
          } else {
            onError(data);
          }
        });
    } else {
      Toast(t("INVITATIONFORM003"), "error");
    }
  };

  const onError = (data) => {
    if (data)
      switch (data.code) {
        case "CVAE1012":
          setError({ firstName: true });
          break;
        case "CVAE1013":
          setError({ firstName: true });
          break;
        case "CVAE1021":
          setError({ scheduledStartDate: true });
          break;
        case "CVAE1022":
          setError({ scheduledEndDate: true });
          break;
        case "CVAE1023":
          setError({ scheduledEndDate: true });
          break;
        case "CVAE0300":
          setError({ siteId: true });
          break;
        default:
          setError({ ...error });
      }
    Toast(data.message, "error");
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const getSiteCurrentDateTime = (siteId) => {
    httpCommon
      .securedAxios() // swap for whatever instance you actually use for GETs — check what handleText() uses as reference
      .get(`/web/visit/site/${siteId}/currectDateTime`)
      .then((response) => {
        if (
          response?.data?.code === "CVAI0000" &&
          response.data.data?.siteCurrentTime
        ) {
          const startDate = new Date(response.data.data.siteCurrentTime);
          setPayload((prev) => ({
            ...prev,
            scheduledStartDate: CommonUtil.formatLocalDateTime(startDate),
            scheduledEndDate: CommonUtil.formatLocalDateTime(
              moment(startDate).add(perRegistrationIntervalTime, "minutes"),
            ),
          }));
          setSiteCurrentDateTime(startDate);
          setSiteTimeEnable(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      PaperProps={{
        style: {
          borderRadius: "20px !important",
          minWidth: "50vw",
          backgroundColor: darkMode ? "rgb(14, 42, 65)" : "#fff",
          color: darkMode ? "#fff" : "#434547",
        },
      }}
      disableBackdropClick
      disableEscapeKeyDown
      BackdropProps={{
        style: {
          backdropFilter: "blur(5px)",
        },
      }}
    >
      <DialogTitle variant="h4">
        <Grid
          container
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Grid item>
            <Typography
              style={{
                color: darkMode ? "#fff" : "black",
                fontSize: "20px",
                fontWeight: "450",
              }}
            >
              {t("PRE_REGISTRATION_CREATE")}
            </Typography>
          </Grid>
          <Grid item>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon onClick={handleClose} />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <Divider
        variant="middle"
        style={{
          background: darkMode
            ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
            : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
          height: "1px",
          opacity: 0.5,
        }}
      />

      <DialogContent
        sx={{
          padding: "24px 24px 8px 24px",
        }}
      >
        <Grid container columnSpacing={2} rowSpacing={3}>
          <Grid item lg={6} sm={12}>
            <CustomTextfield
              label={t("COMMON020")}
              error={error.firstName}
              name="firstName"
              value={payload.firstName}
              handleChange={(e) => handleChange(e)}
              helperText={error.firstName}
              required={true}
              autoComplete="off"
              // inputProps={{ className: classes.input }}
              InputProps={{
                style: {
                  color: darkMode ? "#fff" : "black",
                },
              }}
            />
          </Grid>

          <Grid item lg={6} sm={12}>
            <CustomTextfield
              label={t("COMMON021")}
              error={error.lastName}
              name="lastName"
              value={payload.lastName}
              handleChange={(e) => handleChange(e)}
              helperText={error.lastName}
              autoComplete="off"
              // inputProps={{ className: classes.input }}
              InputProps={{
                style: {
                  color: darkMode ? "#fff" : "black",
                },
              }}
            />
          </Grid>

          <Grid item lg={6} sm={12}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              sx={{ width: "100%" }}
              noOptionsText={"No Options found"}
              name="siteId"
              value={payload.siteId}
              disabled={siteData.length === 1}
              options={CommonUtil.isEmptyArray(siteData) ? [] : siteData}
              getOptionLabel={(option) => (option.name ? option.name : "")}
              onChange={(event, newValue) => {
                if (!CommonUtil.isEmpty(newValue)) {
                  setPayload((prev) => ({
                    ...prev,
                    siteId: newValue,
                    siteTimeZone: newValue.timeZone ? newValue.timeZone : "",
                  }));

                  getSiteCurrentDateTime(newValue.id);
                } else {
                  setPayload((prev) => ({
                    ...prev,
                    siteId: "",
                    siteTimeZone: "",
                  }));

                  setSiteTimeEnable(true);
                  setSiteCurrentDateTime(null);
                }

                setError((prev) => ({
                  ...prev,
                  siteId: false,
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="siteId"
                  required={true}
                  error={error.siteId}
                  variant="outlined"
                  fullWidth
                  label={t("SITE013")}
                />
              )}
            />
          </Grid>

          <Grid item lg={6} xs={12}>
            <CustomDateTimePicker
              onChange={(scheduledStartDate) =>
                setPayload((prev) => ({
                  ...prev,
                  scheduledStartDate: CommonUtil.formatLocalDateTime(
                    scheduledStartDate,
                  ),
                  scheduledEndDate: CommonUtil.formatLocalDateTime(
                    moment(scheduledStartDate).add(
                      perRegistrationIntervalTime,
                      "minutes",
                    ),
                  ),
                }))
              }
              minDateTime={siteCurrentDateTime}
              value={payload.scheduledStartDate}
              label={t("INVITESTARTDATEERROR1")}
              changeDate={changeDate}
              date={date}
              disabled={siteTimeEnable}
            />
          </Grid>
          <Grid item lg={6} xs={12}>
            <CustomDateTimePicker
              onChange={(scheduledEndDate) =>
                setPayload((prev) => ({
                  ...prev,
                  scheduledEndDate: CommonUtil.formatLocalDateTime(
                    scheduledEndDate,
                  ),
                }))
              }
              minDateTime={
                payload.scheduledStartDate
                  ? new Date(payload.scheduledStartDate)
                  : undefined
              }
              value={payload.scheduledEndDate}
              label={t("INVITESTARTDATEERROR2")}
              changeDate={changeDate}
              date={date}
              disabled={siteTimeEnable}
            />
          </Grid>

          <Grid item lg={6} xs={12}>
            <CustomTextfield
              label={t("COMMON016")}
              name="remarks"
              value={payload.remarks}
              handleChange={(e) => handleChange(e)}
              validation="restrictLength"
              autoComplete="off"
              inputProps={{ maxLength: 100 }}
              InputProps={{
                style: {
                  color: darkMode ? "#fff" : "black",
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography
              variant="caption"
              component="p"
              style={{
                color: darkMode ? "#9aa5b1" : "#6b7280",
                // textAlign: "center",
                lineHeight: 1.6,
              }}
            >
              {t("CREATE_PRE_REGISTRATION_CONTANT")}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: "center",
          padding: "16px 24px 24px 24px",
        }}
      >
        <CancelButtons
          variant="contained"
          color="secondary"
          onClick={handleClose}
        >
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {t("COMMON008")}
          </Typography>
        </CancelButtons>
        <SubmitButtons variant="contained" onClick={handleSumbit}>
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {t("COMMON007")}
          </Typography>
        </SubmitButtons>
      </DialogActions>
    </Dialog>
  );
}
